import { ActionOptions } from './Tags.types';

export const ACTION_OPTIONS: ActionOptions[] = [ActionOptions.AddNewTag];

export const visibleElementsWhenSelected = { label: true };
